import '../Login/Login.scss';
import './Connect.scss';
import { ReactNode } from 'react';
import { Alert } from 'react-bootstrap';
import { ConnectFailureType } from '@src/utils/auth/oauth-client';
import { FAILURE_COPY } from './connect-constants';

interface ConnectErrorViewProps {
  failure: ConnectFailureType;
  /** Support reference from the failed request. */
  reference?: string;
  /** The redirect the front refused. Shown as plain text, never as a link. */
  target?: string;
}

export const ConnectErrorView = ({
  failure,
  reference,
  target
}: ConnectErrorViewProps): ReactNode => {
  const { title, body } = FAILURE_COPY[failure];

  return (
    <div className='bpm-login connect-page' data-testid='connect-error'>
      <div className='bpm-login-inner'>
        <div className='login-form'>
          <Alert variant='danger'>
            <Alert.Heading as='h2'>{title}</Alert.Heading>
            {body}
          </Alert>
          {target && (
            <p className='connect-detail'>
              The app asked to be sent to this host:
              <code className='connect-target' data-testid='connect-target'>
                {target}
              </code>
            </p>
          )}
          {reference && (
            <p className='connect-reference' data-testid='connect-reference'>
              Reference: {reference}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
